<router-outlet></router-outlet>

@if (debugService.isDebugEnabled) {
  <dt-debug></dt-debug>
}

<dt-time-tracking></dt-time-tracking>

<div id="dt-debug-error-indicator"> Error </div>

<div id="dt-navi-error" data-cy="navi_error">
  <div class="window">
    <div class="header" i18n>Fehler</div>
    <p class="explanation" i18n
      >Im Entscheidungsnavi ist ein Fehler aufgetreten. Solltest Du fortfahren, kann die ordnungsgemäße Funktionalität des
      Entscheidungsnavis <span class="bold">nicht</span> mehr sichergestellt werden. Falls Du aktuell ein Projekt geladen hast, empfehlen
      wir <span class="bold">dringend</span>, dieses mithilfe des untenstehenden Buttons zu Exportieren und das Navi anschließend neu zu
      laden.</p
    >
    <div class="actions">
      <button id="dt-navi-error-export-button" i18n>Exportieren</button>
      <button id="dt-navi-error-continue-button" i18n>Fortfahren</button>
    </div>
  </div>
</div>
